import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';

import { translate } from 'containers/services/translate';
import { Listings } from 'containers/AppContainer/typings';
import { COLORS } from 'constants/design';
import { KeycloakUser } from 'containers/RecapManagerPage/typings';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { CivilProceedingInfo } from 'containers/LawyerLegalProceedingsPage/typings';
import AssignBlocForm from 'containers/CourtManagerLegalProceedings/AssignementCivilProceeding/index';
import {
  CIVIL_PROCEEDING_INFORMATIONS_FIELDS,
  LISTINGS,
} from 'containers/data-structure';
import messages from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/messages';

const StyledDiv = styled.div`
  width: 576px;
  display: flex;
  align-items: center;
  justify-content: center;

  .select {
    width: 100%;
    margin-bottom: 33px;
    font-size: 13px;
  }
`;
const StyledDialogActions = styled(DialogActions)`
  display: flex;
  padding: 20px 30px;
  justify-content: space-between;

  .moveButton {
    border: 1px solid ${COLORS.YELLOW};
    background-color: ${COLORS.YELLOW};
    color: ${COLORS.LIMED_SPURCE};
    &:hover {
      background-color: ${COLORS.YELLOW};
    }
  }

  .Mui-disabled {
    opacity: 0.6;
  }
`;

export interface AssignmentDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  setCivilProceedingInfo: Function;
  handleValidation: any;
  civilProceedingInfo: CivilProceedingInfo;
  listings: Listings;
  judiciaryProcessId: number;
  requestCorporealLawyers?: Function;
  corporealLawyers: KeycloakUser[];
}

const AssignmentDialog: React.FC<AssignmentDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;

  const handleClose = () => {
    onClose();
  };

  const handleChange = (field: string) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    props.setCivilProceedingInfo({
      ...props.civilProceedingInfo,
      [field]: event.target.value,
    });
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        {translate({ ...messages.assignmentDialogTitle }, props)}
      </DialogTitle>
      <DialogContent>
        <StyledDiv>
          <AssignBlocForm
            subServices={get(props.listings, LISTINGS.SUB_SERVICES, [])}
            zonesCodes={get(props.listings, LISTINGS.ZONE_CODES, [])}
            services={get(props.listings, LISTINGS.SERVICES, [])}
            stackholders={get(props.listings, LISTINGS.STACKHOLDERS, [])}
            stackholderTypes={get(
              props.listings,
              LISTINGS.STACKHOLDER_TYPE,
              [],
            )}
            requestCorporealLawyers={props.requestCorporealLawyers}
            corporealLawyers={props.corporealLawyers}
            handleChangeAssignedLawyer={handleChange(
              CIVIL_PROCEEDING_INFORMATIONS_FIELDS.ASSIGNED_LAWYER,
            )}
          />
        </StyledDiv>
      </DialogContent>
      <StyledDialogActions>
        <SecondaryButton
          onClick={handleClose}
          disableElevation
          title={translate({ ...messages.assignmentDialogCancelButton }, props)}
        />
        <PrimaryButton
          onClick={props.handleValidation}
          disabled={isEmpty(
            get(props, 'civilProceedingInfo.assignedLawyer', ''),
          )}
          title={translate(
            { ...messages.assignmentDialogValidationButton },
            props,
          )}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

AssignmentDialog.defaultProps = {
  open: false,
};

export default injectIntl(AssignmentDialog);
